import type { Snowplow } from "@simplybusiness/services";

export const triggerTradeSelectorClicked = (snowplow?: Snowplow) => {
  snowplow?.trigger("tradeSelectorClicked");
};

export const triggerTradeChanged = (
  snowplow: Snowplow | undefined,
  questionId: string | undefined,
  answeredTrade: string,
) => {
  snowplow?.trigger("tradeChanged", {
    label: questionId,
    property: answeredTrade,
  });
};

export const triggerAiFindMyBusiness = (
  snowplow: Snowplow | undefined,
  searchQuery: string,
) => {
  snowplow?.trigger("aiTradeSelectorFindMyBusiness", {
    searchQuery,
  });
};
